import {axios} from '@/lib/axios';

export const getDrmPfBaseData = (id: string | undefined): Promise<any> => {
  return axios.get(`/api/v1/customers/getDrmPfBaseData`, {
    params: {id}
  })
}

// すべての利用履歴を取得
export const getUsageHistory = (month: string | undefined): Promise<any> => {
  return axios.get(`/api/v1/customers/getUsageHistory`, {
  })
}

export const getDrmPfDocumentDownload = () => {
  return axios.get(`/api/v1/Customers/getDataDocuments`)
}